module.exports = __webpack_public_path__ + "images/unsplash_large.jpg";